export default __webpack_public_path__ + "static/media/logo-next.4589d0a2.svg";